import { useApplicationsQuery } from './useApplicationsQuery';
import { useApplicationsSearch } from './useApplicationsSearch';
import { columns } from '../tables/columns';

export const useApplications = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useApplicationsQuery(filters);
    const { keyword } = useApplicationsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
